<script setup lang="ts">
import { useProductInfo } from "~/composables/useProductInfo";
import ProductCard from "~/components/Register/ProductCard.vue";
import type { Product } from "~/types";
import { useProcessStore } from "~/stores/process/store";

const processStore = useProcessStore();

const { products, pending } = useProductInfo();

async function selectPlan(product: Product) {
  processStore.selectedPlan = product;
  await navigateTo("/register");
}
</script>

<template>
  <div class="my-10">
    <div class="mb-2 text-3xl font-bold">
      Choose the plan that's right for you
    </div>
    <div class="mb-5 text-surface-300">
      Join PokerGO and select from our flexible subscription options tailored to
      suit your viewing preferences. Get ready for non-stop Poker!
    </div>

    <div v-if="pending" class="mt-20 text-center">
      <ProgressSpinner class="!h-20 !w-20" />
    </div>
    <div v-else>
      <div class="flex flex-col flex-wrap justify-center gap-5 md:flex-row">
        <div
          v-for="(product, idx) in products"
          :key="`product_${idx}`"
          class="flex-shrink-0"
        >
          <ProductCard :product="product" @handle-action="selectPlan" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
